import React from "react";
import Link from "next/link";
import moment from "moment-timezone";
import styles from "src/components/FreeTrialBanner/styles.scss";
import BetQLLogo from "src/components/BetQLLogo";
import { LeaguePromo } from "src/services/SubscriptionService";

/**
 * Shown while the user has free access to a league without a subscription
 */
const LeaguePromoBanner = ({ promo }: { promo: LeaguePromo }) => {
  // Promos end at midnight, so show the last full day
  const lastDay = moment(promo.endsAt).subtract(1, "second").format("MMM D");

  return (
    <div className="trial-banner">
      <div className="offer-logos">
        <BetQLLogo color="white" style={{ height: 18 }} />
      </div>
      <span style={{ width: 10 }} />
      <div className="offer-text">
        Free {promo.league} access through {lastDay} - enjoy!
      </div>
      <span style={{ width: 16, height: 6 }} />
      <Link
        href={{ pathname: "/subscribe", query: { source: "League Promo Banner", sport: promo.league } }}
        legacyBehavior
      >
        <a className="white-button">Subscribe</a>
      </Link>
      <style jsx global>
        {styles}
      </style>
    </div>
  );
};

export default LeaguePromoBanner;
